import { RefreshIcon } from '@customink/pigment-react';
import * as React from 'react';
import styles from './index.module.css';

const Spinner: React.FC = () => <RefreshIcon className={styles.animationSpin} />;

export default Spinner;
